<div class="input-group">

  <div>
    <div class="form-check form-switch">
      <input class="form-check-input" type="checkbox" id="periodSelect" [(ngModel)]="periodFilter" name="periodly"
        #periodly="ngModel" (change)="setDateFilter($event,'period');">
        <label class="form-check-label" for="periodly">
          Period
        </label>
      </div>
      <select [(ngModel)]="datePeriod" id="value" class="form-control" name="period" [disabled]="!periodFilter"
        #period="ngModel" (change)="onChangePeriod($event.target.value)">
        @for (value of datePeriods; track value) {
          <option value={{value.key}}>
            {{value.name}}
          </option>
        }
      </select>
    </div>

    <span class="input-group-addon">&nbsp;</span>

    <div style="width: 30%;">
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" id="rangeSelect" [(ngModel)]="rangeFilter" name="rangely"
          #rangely="ngModel" (change)="setDateFilter($event,'range');">
          <label class="form-check-label" for="rangely">
            Range
          </label>
        </div>
        <input type="text" name="rangeSelector" autocomplete="off" [(ngModel)]="dateRange" placeholder=""
          class="form-control" bsDaterangepicker [disabled]="!rangeFilter" (ngModelChange)="onChangeRange($event)">
        </div>
      </div>
